export interface PillarMeta {
  slug: string;
  image: string;
  related: string[];
}

export const PILLARS: PillarMeta[] = [
  {
    slug: 'review',
    image: "https://readdy.ai/api/search-image?query=Hands%20holding%20a%20smartphone%20showing%20an%20online%20shopping%20app%20over%20a%20clean%20bright%20desk%20with%20a%20small%20notebook%2C%20warm%20natural%20window%20light%2C%20minimal%20editorial%20lifestyle%20photography%2C%20fresh%20and%20tidy%20composition%2C%20soft%20neutral%20background&width=800&height=500&seq=pillar-review-01&orientation=landscape",
    related: ['legit', 'safety', 'comparison'],
  },
  {
    slug: 'shipping-cost',
    image: "https://readdy.ai/api/search-image?query=A%20neat%20stack%20of%20small%20kraft%20cardboard%20shipping%20boxes%20with%20a%20tape%20measure%20and%20a%20calculator%20on%20a%20light%20wooden%20desk%2C%20soft%20warm%20daylight%2C%20minimal%20fresh%20editorial%20product%20photography%2C%20clean%20uncluttered%20composition&width=800&height=500&seq=pillar-shipping-02&orientation=landscape",
    related: ['warehouse', 'shopping-guide', 'comparison'],
  },
  {
    slug: 'coupon',
    image: "https://readdy.ai/api/search-image?query=A%20tidy%20arrangement%20of%20paper%20discount%20coupon%20tags%20and%20a%20small%20pair%20of%20scissors%20on%20a%20soft%20sage%20green%20background%2C%20warm%20minimal%20fresh%20editorial%20photography%2C%20gentle%20shadows%2C%20clean%20composition&width=800&height=500&seq=pillar-coupon-03&orientation=landscape",
    related: ['discount-code', 'shopping-guide', 'review'],
  },
  {
    slug: 'discount-code',
    image: "https://readdy.ai/api/search-image?query=A%20laptop%20keyboard%20with%20a%20small%20shopping%20bag%20and%20a%20gift%20tag%20on%20a%20light%20wooden%20desk%2C%20soft%20warm%20natural%20light%2C%20minimal%20fresh%20editorial%20photography%2C%20clean%20and%20tidy%20uncluttered%20composition&width=800&height=500&seq=pillar-discount-04&orientation=landscape",
    related: ['coupon', 'shopping-guide', 'comparison'],
  },
  {
    slug: 'warehouse',
    image: "https://readdy.ai/api/search-image?query=A%20clean%20modern%20warehouse%20aisle%20with%20neatly%20organized%20shelves%20of%20stacked%20cardboard%20boxes%2C%20soft%20diffused%20daylight%2C%20fresh%20minimal%20editorial%20photography%2C%20bright%20and%20orderly%20atmosphere&width=800&height=500&seq=pillar-warehouse-05&orientation=landscape",
    related: ['qc', 'shipping-cost', 'safety'],
  },
  {
    slug: 'legit',
    image: "https://readdy.ai/api/search-image?query=A%20pair%20of%20reading%20glasses%20resting%20on%20a%20clipboard%20checklist%20with%20a%20green%20check%20mark%2C%20warm%20minimal%20editorial%20photography%20on%20a%20clean%20light%20desk%2C%20soft%20natural%20light%2C%20fresh%20and%20tidy%20composition&width=800&height=500&seq=pillar-legit-06&orientation=landscape",
    related: ['safety', 'review', 'comparison'],
  },
  {
    slug: 'safety',
    image: "https://readdy.ai/api/search-image?query=A%20small%20brass%20padlock%20and%20a%20payment%20card%20resting%20on%20a%20clean%20light%20surface%20with%20soft%20natural%20light%2C%20warm%20minimal%20fresh%20editorial%20photography%2C%20gentle%20shadows%2C%20simple%20uncluttered%20composition&width=800&height=500&seq=pillar-safety-07&orientation=landscape",
    related: ['legit', 'qc', 'shopping-guide'],
  },
  {
    slug: 'qc',
    image: "https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20inspecting%20a%20neatly%20folded%20t-shirt%20on%20a%20light%20wooden%20table%2C%20soft%20natural%20window%20light%2C%20minimal%20fresh%20editorial%20photography%2C%20clean%20and%20detailed%20uncluttered%20composition&width=800&height=500&seq=pillar-qc-08&orientation=landscape",
    related: ['warehouse', 'safety', 'comparison'],
  },
  {
    slug: 'shopping-guide',
    image: "https://readdy.ai/api/search-image?query=A%20neatly%20organized%20shopping%20basket%20with%20folded%20clothing%20items%20on%20a%20light%20background%2C%20warm%20minimal%20editorial%20photography%2C%20soft%20natural%20light%2C%20fresh%20and%20tidy%20composition&width=800&height=500&seq=pillar-shopping-09&orientation=landscape",
    related: ['comparison', 'shipping-cost', 'review'],
  },
  {
    slug: 'comparison',
    image: "https://readdy.ai/api/search-image?query=Two%20side%20by%20side%20product%20cards%20being%20compared%20on%20a%20clean%20light%20desk%20with%20a%20small%20notebook%20and%20pen%2C%20warm%20minimal%20editorial%20photography%2C%20soft%20natural%20light%2C%20fresh%20and%20tidy%20composition&width=800&height=500&seq=pillar-comparison-10&orientation=landscape",
    related: ['shopping-guide', 'shipping-cost', 'review'],
  },
];